import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppFacadeService } from './app-facade.service';
import { RouterFacadeService } from './router-facade.service';

/**
 * RoleGuard manages the access specific sections
 * depending on the logged user role. If the user role is correct, it allows access to section;
 * if not the correct role, it will take you to the main section that your role allows
 */
@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate {

    /**
     * RoleGuard Constructor
     * @param appFacadeService The app facade service to get the logged user information
     * @param routerFacadeService The router service to lead the user to a section depending on the role
     */
    constructor(
        private appFacadeService: AppFacadeService,
        private routerFacadeService: RouterFacadeService,
    ) { }

    /**
     * This method evaluate if user can access to some section 
     * page or to the home page. When the observable emmits true the user will be leaded
     * to required section, otherwise the user will be
     * leaded to the login page where {@link AuthGuard} takes place. 
     * Please refer to {@link /miscellaneous/enumerations.html#Roles|User Roles}
     * @param next Contains the information about the route to be accessed
     * @param _state Represents the state of the router in that moment
     * @returns An observable of a boolean that indicates if the user can either navigate or not to the section
     * .
     */
    canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.appFacadeService.getLoggedUser$().pipe(
            map((user) => {
                if (next.data.role.includes(user.role.name)) {
                    return true
                } else {
                    this.routerFacadeService.navigateTo$('auth')
                    return false;
                }
            })
        )
    }
}
